import { render } from "./AttachPatient.vue?vue&type=template&id=87e56908"
import script from "./AttachPatient.vue?vue&type=script&lang=js"
export * from "./AttachPatient.vue?vue&type=script&lang=js"

import "./AttachPatient.vue?vue&type=style&index=0&id=87e56908&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__